function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ItemBoundable from './ItemBoundable';
import hasInterface from '../../../../../hasInterface';
import ItemVisitor from '../ItemVisitor';
import AbstractNode from './AbstractNode';
import Collections from '../../../../../java/util/Collections';
import ArrayList from '../../../../../java/util/ArrayList';
import Serializable from '../../../../../java/io/Serializable';
import Assert from '../../util/Assert';
import List from '../../../../../java/util/List';
var AbstractSTRtree = /*#__PURE__*/function () {
  function AbstractSTRtree() {
    _classCallCheck(this, AbstractSTRtree);
    AbstractSTRtree.constructor_.apply(this, arguments);
  }
  return _createClass(AbstractSTRtree, [{
    key: "queryInternal",
    value: function queryInternal() {
      if (hasInterface(arguments[2], ItemVisitor) && arguments[0] instanceof Object && arguments[1] instanceof AbstractNode) {
        var searchBounds = arguments[0];
        var node = arguments[1];
        var visitor = arguments[2];
        var childBoundables = node.getChildBoundables();
        for (var i = 0; i < childBoundables.size(); i++) {
          var childBoundable = childBoundables.get(i);
          if (!this.getIntersectsOp().intersects(childBoundable.getBounds(), searchBounds)) {
            continue;
          }
          if (childBoundable instanceof AbstractNode) {
            this.queryInternal(searchBounds, childBoundable, visitor);
          } else if (childBoundable instanceof ItemBoundable) {
            visitor.visitItem(childBoundable.getItem());
          } else {
            Assert.shouldNeverReachHere();
          }
        }
      } else if (hasInterface(arguments[2], List) && arguments[0] instanceof Object && arguments[1] instanceof AbstractNode) {
        var _searchBounds = arguments[0];
        var _node = arguments[1];
        var matches = arguments[2];
        var _childBoundables = _node.getChildBoundables();
        for (var _i = 0; _i < _childBoundables.size(); _i++) {
          var _childBoundable = _childBoundables.get(_i);
          if (!this.getIntersectsOp().intersects(_childBoundable.getBounds(), _searchBounds)) {
            continue;
          }
          if (_childBoundable instanceof AbstractNode) {
            this.queryInternal(_searchBounds, _childBoundable, matches);
          } else if (_childBoundable instanceof ItemBoundable) {
            matches.add(_childBoundable.getItem());
          } else {
            Assert.shouldNeverReachHere();
          }
        }
      }
    }
  }, {
    key: "getNodeCapacity",
    value: function getNodeCapacity() {
      return this._nodeCapacity;
    }
  }, {
    key: "lastNode",
    value: function lastNode(nodes) {
      return nodes.get(nodes.size() - 1);
    }
  }, {
    key: "size",
    value: function size() {
      if (arguments.length === 0) {
        if (this.isEmpty()) {
          return 0;
        }
        this.build();
        return this.size(this._root);
      } else if (arguments.length === 1) {
        var node = arguments[0];
        var _size = 0;
        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();
          if (childBoundable instanceof AbstractNode) {
            _size += this.size(childBoundable);
          } else if (childBoundable instanceof ItemBoundable) {
            _size += 1;
          }
        }
        return _size;
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(node, item) {
      var childToRemove = null;
      for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
        var childBoundable = i.next();
        if (childBoundable instanceof ItemBoundable) {
          if (childBoundable.getItem() === item) childToRemove = childBoundable;
        }
      }
      if (childToRemove !== null) {
        node.getChildBoundables().remove(childToRemove);
        return true;
      }
      return false;
    }
  }, {
    key: "itemsTree",
    value: function itemsTree() {
      if (arguments.length === 0) {
        this.build();
        var valuesTree = this.itemsTree(this._root);
        if (valuesTree === null) return new ArrayList();
        return valuesTree;
      } else if (arguments.length === 1) {
        var node = arguments[0];
        var valuesTreeForNode = new ArrayList();
        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();
          if (childBoundable instanceof AbstractNode) {
            var valuesTreeForChild = this.itemsTree(childBoundable);
            if (valuesTreeForChild !== null) valuesTreeForNode.add(valuesTreeForChild);
          } else if (childBoundable instanceof ItemBoundable) {
            valuesTreeForNode.add(childBoundable.getItem());
          } else {
            Assert.shouldNeverReachHere();
          }
        }
        if (valuesTreeForNode.size() <= 0) return null;
        return valuesTreeForNode;
      }
    }
  }, {
    key: "insert",
    value: function insert(bounds, item) {
      Assert.isTrue(!this._built, 'Cannot insert items into an STR packed R-tree after it has been built.');
      this._itemBoundables.add(new ItemBoundable(bounds, item));
    }
  }, {
    key: "boundablesAtLevel",
    value: function boundablesAtLevel() {
      if (arguments.length === 1) {
        var level = arguments[0];
        var boundables = new ArrayList();
        this.boundablesAtLevel(level, this._root, boundables);
        return boundables;
      } else if (arguments.length === 3) {
        var _level = arguments[0];
        var top = arguments[1];
        var _boundables = arguments[2];
        Assert.isTrue(_level > -2);
        if (top.getLevel() === _level) {
          _boundables.add(top);
          return null;
        }
        for (var i = top.getChildBoundables().iterator(); i.hasNext();) {
          var boundable = i.next();
          if (boundable instanceof AbstractNode) {
            this.boundablesAtLevel(_level, boundable, _boundables);
          } else {
            Assert.isTrue(boundable instanceof ItemBoundable);
            if (_level === -1) {
              _boundables.add(boundable);
            }
          }
        }
        return null;
      }
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 1) {
        var searchBounds = arguments[0];
        this.build();
        var matches = new ArrayList();
        if (this.isEmpty()) {
          return matches;
        }
        if (this.getIntersectsOp().intersects(this._root.getBounds(), searchBounds)) {
          this.queryInternal(searchBounds, this._root, matches);
        }
        return matches;
      } else if (arguments.length === 2) {
        var _searchBounds2 = arguments[0];
        var visitor = arguments[1];
        this.build();
        if (this.isEmpty()) {
          return null;
        }
        if (this.getIntersectsOp().intersects(this._root.getBounds(), _searchBounds2)) {
          this.queryInternal(_searchBounds2, this._root, visitor);
        }
      }
    }
  }, {
    key: "build",
    value: function build() {
      if (this._built) return null;
      this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1);
      this._itemBoundables = null;
      this._built = true;
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      this.build();
      return this._root;
    }
  }, {
    key: "remove",
    value: function remove() {
      if (arguments.length === 2) {
        var searchBounds = arguments[0];
        var item = arguments[1];
        this.build();
        if (this.getIntersectsOp().intersects(this._root.getBounds(), searchBounds)) {
          return this.remove(searchBounds, this._root, item);
        }
        return false;
      } else if (arguments.length === 3) {
        var _searchBounds3 = arguments[0];
        var node = arguments[1];
        var _item = arguments[2];
        var found = this.removeItem(node, _item);
        if (found) return true;
        var childToPrune = null;
        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();
          if (!this.getIntersectsOp().intersects(childBoundable.getBounds(), _searchBounds3)) {
            continue;
          }
          if (childBoundable instanceof AbstractNode) {
            found = this.remove(_searchBounds3, childBoundable, _item);
            if (found) {
              childToPrune = childBoundable;
              break;
            }
          }
        }
        if (childToPrune !== null) {
          if (childToPrune.getChildBoundables().isEmpty()) {
            node.getChildBoundables().remove(childToPrune);
          }
        }
        return found;
      }
    }
  }, {
    key: "createHigherLevels",
    value: function createHigherLevels(boundablesOfALevel, level) {
      Assert.isTrue(!boundablesOfALevel.isEmpty());
      var parentBoundables = this.createParentBoundables(boundablesOfALevel, level + 1);
      if (parentBoundables.size() === 1) {
        return parentBoundables.get(0);
      }
      return this.createHigherLevels(parentBoundables, level + 1);
    }
  }, {
    key: "depth",
    value: function depth() {
      if (arguments.length === 0) {
        if (this.isEmpty()) {
          return 0;
        }
        this.build();
        return this.depth(this._root);
      } else if (arguments.length === 1) {
        var node = arguments[0];
        var maxChildDepth = 0;
        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();
          if (childBoundable instanceof AbstractNode) {
            var childDepth = this.depth(childBoundable);
            if (childDepth > maxChildDepth) maxChildDepth = childDepth;
          }
        }
        return maxChildDepth + 1;
      }
    }
  }, {
    key: "createParentBoundables",
    value: function createParentBoundables(childBoundables, newLevel) {
      Assert.isTrue(!childBoundables.isEmpty());
      var parentBoundables = new ArrayList();
      parentBoundables.add(this.createNode(newLevel));
      var sortedChildBoundables = new ArrayList(childBoundables);
      Collections.sort(sortedChildBoundables, this.getComparator());
      for (var i = sortedChildBoundables.iterator(); i.hasNext();) {
        var childBoundable = i.next();
        if (this.lastNode(parentBoundables).getChildBoundables().size() === this.getNodeCapacity()) {
          parentBoundables.add(this.createNode(newLevel));
        }
        this.lastNode(parentBoundables).addChildBoundable(childBoundable);
      }
      return parentBoundables;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      if (!this._built) return this._itemBoundables.isEmpty();
      return this._root.isEmpty();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return AbstractSTRtree;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable];
    }
  }], [{
    key: "compareDoubles",
    value: function compareDoubles(a, b) {
      return a > b ? 1 : a < b ? -1 : 0;
    }
  }]);
}();
export { AbstractSTRtree as default };
function IntersectsOp() {}
AbstractSTRtree.IntersectsOp = IntersectsOp;
AbstractSTRtree.constructor_ = function () {
  this._root = null;
  this._built = false;
  this._itemBoundables = new ArrayList();
  this._nodeCapacity = null;
  if (arguments.length === 0) {
    AbstractSTRtree.constructor_.call(this, AbstractSTRtree.DEFAULT_NODE_CAPACITY);
  } else if (arguments.length === 1) {
    var nodeCapacity = arguments[0];
    Assert.isTrue(nodeCapacity > 1, 'Node capacity must be greater than 1');
    this._nodeCapacity = nodeCapacity;
  }
};
AbstractSTRtree.serialVersionUID = -3886435814360241337;
AbstractSTRtree.DEFAULT_NODE_CAPACITY = 10;